import type { ReactNode } from "react";
import { cn } from "./ui/utils";

interface ContentStateProps {
	icon?: ReactNode;
	title: ReactNode;
	description?: ReactNode;
	action?: ReactNode;
	className?: string;
}

export function ContentState({
	icon,
	title,
	description,
	action,
	className,
}: ContentStateProps) {
	return (
		<div
			className={cn(
				"flex min-h-56 flex-col items-center justify-center px-6 py-10 text-center",
				className,
			)}
		>
			{icon ? (
				<div className="mb-4 flex h-11 w-11 items-center justify-center rounded-sm bg-secondary text-muted-foreground">
					{icon}
				</div>
			) : null}
			<h2 className="text-base font-bold text-foreground">{title}</h2>
			{description ? (
				<p className="mt-1 max-w-lg text-sm leading-6 text-muted-foreground">
					{description}
				</p>
			) : null}
			{action ? <div className="mt-5">{action}</div> : null}
		</div>
	);
}
